// extracted by mini-css-extract-plugin
export default {"background":"lB2qB1ZiaPAjROeOEB0_"};